/* @flow */
import {useQuery} from '@apollo/react-hooks';

import {makeDataSafe, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import type {GetUnlockInfo as GetUnlockInfoQuery} from 'nutshell-graphql-types';

import GET_UNLOCK_INFO from '../../graphql/queries/get-unlock-info.graphql';

type UnlockInfo = {
    __typename: 'UnlockInfo',
    unlockLimit: number,
    unlockedThisMonth: number,
};

export const useGetUnlockInfo = (): {
    isLoading: boolean,
    error: ?string,
    unlockInfo: ?UnlockInfo,
} => {
    const {data, loading: isLoading, error} = useQuery<GetUnlockInfoQuery, {}>(GET_UNLOCK_INFO, {});

    const {unlockInfo} = makeDataSafe(data);

    return {
        isLoading,
        error: safelyGetGraphQLErrorMessage(error),
        unlockInfo,
    };
};
